import { createSelector } from '@reduxjs/toolkit';

import { type PromptState } from './slice';

export const selectIsOpened = (state: PromptState) => state['@@PROMPT'].portal.open;
export const selectPortalProps = (state: PromptState) => state['@@PROMPT'].portal;
export const selectCurrentType = (state: PromptState) => state['@@PROMPT'].portal?.currentType;

const selectModalPropsFn = (state: PromptState) => state['@@PROMPT'].modalPropsFn;

export const selectModalProps = createSelector(selectModalPropsFn, fn => fn());
